import {IPersonalizedHomepageBackgroundImages} from "../components/PersonalizedHomepage/PersonalizedHomepageHero";

export const PERSONALIZED_HERO_CITY_BACKGROUNDS: Record<string, IPersonalizedHomepageBackgroundImages> = {
    bialystok: {
        mobile: require("../images/hero/mobile/bialystok.jpg"),
        desktopSmall: require("../images/hero/desktop_small/bialystok.jpg"),
        desktopBig: require("../images/hero/desktop_big/bialystok.jpg")
    },
    bydgoszcz: {
        mobile: require("../images/hero/mobile/bydgoszcz.jpg"),
        desktopSmall: require("../images/hero/desktop_small/bydgoszcz.jpg"),
        desktopBig: require("../images/hero/desktop_big/bydgoszcz.jpg")
    },
    gdansk: {
        mobile: require("../images/hero/mobile/gdansk.jpg"),
        desktopSmall: require("../images/hero/desktop_small/gdansk.jpg"),
        desktopBig: require("../images/hero/desktop_big/gdansk.jpg")
    },
    gdynia: {
        mobile: require("../images/hero/mobile/gdynia.jpg"),
        desktopSmall: require("../images/hero/desktop_small/gdynia.jpg"),
        desktopBig: require("../images/hero/desktop_big/gdynia.jpg")
    },
    katowice: {
        mobile: require("../images/hero/mobile/katowice.jpg"),
        desktopSmall: require("../images/hero/desktop_small/katowice.jpg"),
        desktopBig: require("../images/hero/desktop_big/katowice.jpg")
    },
    krakow: {
        mobile: require("../images/hero/mobile/krakow.jpg"),
        desktopSmall: require("../images/hero/desktop_small/krakow.jpg"),
        desktopBig: require("../images/hero/desktop_big/krakow.jpg")
    },
    lublin: {
        mobile: require("../images/hero/mobile/lublin.jpg"),
        desktopSmall: require("../images/hero/desktop_small/lublin.jpg"),
        desktopBig: require("../images/hero/desktop_big/lublin.jpg")
    },
    poznan: {
        mobile: require("../images/hero/mobile/poznan.jpg"),
        desktopSmall: require("../images/hero/desktop_small/poznan.jpg"),
        desktopBig: require("../images/hero/desktop_big/poznan.jpg")
    },
    warszawa: {
        mobile: require("../images/hero/mobile/warszawa.jpg"),
        desktopSmall: require("../images/hero/desktop_small/warszawa.jpg"),
        desktopBig: require("../images/hero/desktop_big/warszawa.jpg")
    },
    wroclaw: {
        mobile: require("../images/hero/mobile/wroclaw.jpg"),
        desktopSmall: require("../images/hero/desktop_small/wroclaw.jpg"),
        desktopBig: require("../images/hero/desktop_big/wroclaw.jpg")
    }
};

/**
 * Neutral, non-identifiable photos (shared with the public HomepageHeader) for
 * searches outside the covered cities — a recognizable skyline of a different
 * city would read as a mismatch.
 */
export const PERSONALIZED_HERO_DEFAULT_BACKGROUNDS: IPersonalizedHomepageBackgroundImages[] = [
    {
        mobile: require("../images/header_1_mobile.jpg"),
        desktopSmall: require("../images/header_1_desktop_small.jpg"),
        desktopBig: require("../images/header_1_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_2_mobile.jpg"),
        desktopSmall: require("../images/header_2_desktop_small.jpg"),
        desktopBig: require("../images/header_2_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_3_mobile.jpg"),
        desktopSmall: require("../images/header_3_desktop_small.jpg"),
        desktopBig: require("../images/header_3_desktop_big.jpg")
    }
];
import {IPersonalizedHomepageBackgroundImages} from "../components/PersonalizedHomepage/PersonalizedHomepageHero";

export const PERSONALIZED_HERO_CITY_BACKGROUNDS: Record<string, IPersonalizedHomepageBackgroundImages> = {
    bialystok: {
        mobile: require("../images/hero/mobile/bialystok.jpg"),
        desktopSmall: require("../images/hero/desktop_small/bialystok.jpg"),
        desktopBig: require("../images/hero/desktop_big/bialystok.jpg")
    },
    bydgoszcz: {
        mobile: require("../images/hero/mobile/bydgoszcz.jpg"),
        desktopSmall: require("../images/hero/desktop_small/bydgoszcz.jpg"),
        desktopBig: require("../images/hero/desktop_big/bydgoszcz.jpg")
    },
    gdansk: {
        mobile: require("../images/hero/mobile/gdansk.jpg"),
        desktopSmall: require("../images/hero/desktop_small/gdansk.jpg"),
        desktopBig: require("../images/hero/desktop_big/gdansk.jpg")
    },
    gdynia: {
        mobile: require("../images/hero/mobile/gdynia.jpg"),
        desktopSmall: require("../images/hero/desktop_small/gdynia.jpg"),
        desktopBig: require("../images/hero/desktop_big/gdynia.jpg")
    },
    katowice: {
        mobile: require("../images/hero/mobile/katowice.jpg"),
        desktopSmall: require("../images/hero/desktop_small/katowice.jpg"),
        desktopBig: require("../images/hero/desktop_big/katowice.jpg")
    },
    krakow: {
        mobile: require("../images/hero/mobile/krakow.jpg"),
        desktopSmall: require("../images/hero/desktop_small/krakow.jpg"),
        desktopBig: require("../images/hero/desktop_big/krakow.jpg")
    },
    lublin: {
        mobile: require("../images/hero/mobile/lublin.jpg"),
        desktopSmall: require("../images/hero/desktop_small/lublin.jpg"),
        desktopBig: require("../images/hero/desktop_big/lublin.jpg")
    },
    poznan: {
        mobile: require("../images/hero/mobile/poznan.jpg"),
        desktopSmall: require("../images/hero/desktop_small/poznan.jpg"),
        desktopBig: require("../images/hero/desktop_big/poznan.jpg")
    },
    warszawa: {
        mobile: require("../images/hero/mobile/warszawa.jpg"),
        desktopSmall: require("../images/hero/desktop_small/warszawa.jpg"),
        desktopBig: require("../images/hero/desktop_big/warszawa.jpg")
    },
    wroclaw: {
        mobile: require("../images/hero/mobile/wroclaw.jpg"),
        desktopSmall: require("../images/hero/desktop_small/wroclaw.jpg"),
        desktopBig: require("../images/hero/desktop_big/wroclaw.jpg")
    }
};

/**
 * Neutral, non-identifiable photos (shared with the public HomepageHeader) for
 * searches outside the covered cities — a recognizable skyline of a different
 * city would read as a mismatch.
 */
export const PERSONALIZED_HERO_DEFAULT_BACKGROUNDS: IPersonalizedHomepageBackgroundImages[] = [
    {
        mobile: require("../images/header_1_mobile.jpg"),
        desktopSmall: require("../images/header_1_desktop_small.jpg"),
        desktopBig: require("../images/header_1_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_2_mobile.jpg"),
        desktopSmall: require("../images/header_2_desktop_small.jpg"),
        desktopBig: require("../images/header_2_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_3_mobile.jpg"),
        desktopSmall: require("../images/header_3_desktop_small.jpg"),
        desktopBig: require("../images/header_3_desktop_big.jpg")
    }
];
